import {SVGProps} from "types/SVG";

export const CarDiagram = ({alt, className}: SVGProps) => (
    <svg width="169" height="343" viewBox="0 0 169 343" fill="none" xmlns="http://www.w3.org/2000/svg"
         className={className}>
        <g clip-path="url(#clip0_3545_19972)">
            <path
                d="M111.143 334.02L84.3859 335.911L57.6288 334.02L51.1895 339.828C57.6096 341.911 64.3373 342.981 71.0842 342.981H82.7905H85.9621H97.6683C104.434 342.981 111.143 341.911 117.563 339.828L111.143 334.02Z"
                fill="url(#paint0_linear_3545_19972)"/>
            <path
                d="M109.047 339.331V340.822C109.047 340.822 121.291 340.936 133.728 338.185L133.209 335.07L132.594 331.287C132.575 331.287 111.757 335.185 109.047 339.331Z"
                fill="#2C3E54"/>
            <path
                d="M132.46 309.695L85.0004 322.899L37.5412 309.695L35.7344 330.924C35.7344 330.924 54.918 335.242 60.9537 339.312H82.8475H87.1341H109.028C115.064 335.242 134.247 330.924 134.247 330.924L132.46 309.695Z"
                fill="#4B6C8C"/>
            <path
                d="M43.0772 255.773L125.52 256.633L131.46 294.447L130.595 301.097L38.7715 301.307L39.9632 282.887L43.0772 255.773Z"
                fill="url(#paint1_linear_3545_19972)"/>
            <path
                d="M125.809 295.461C114.929 296.932 91.6323 297.238 84.4241 297.295C77.2158 297.238 53.9379 296.932 43.0391 295.461L46.6144 322.67C46.6144 322.67 50.7279 324.18 82.252 324.313C82.9824 324.313 83.7129 324.313 84.4241 324.313C85.1353 324.313 85.8657 324.313 86.5962 324.313C118.12 324.18 122.234 322.67 122.234 322.67L125.809 295.461Z"
                fill="#4B6C8C"/>
            <path
                d="M125.674 296.396C114.795 297.868 91.4976 298.174 84.2893 298.231C77.081 298.174 53.8032 297.868 42.9043 296.396L46.4796 323.606C46.4796 323.606 50.5931 325.115 82.1172 325.249C82.8477 325.249 83.5781 325.249 84.2893 325.249C85.0005 325.249 85.731 325.249 86.4614 325.249C117.986 325.115 122.099 323.606 122.099 323.606L125.674 296.396Z"
                fill="url(#paint2_linear_3545_19972)"/>
            <path
                d="M129.538 147.206C129.538 147.206 81.829 140.251 34.6582 148.773L40.5978 167.078H128.289L129.538 147.206Z"
                fill="url(#paint3_linear_3545_19972)"/>
            <path d="M127.654 12.1719L143.858 23.56L148.299 33.3813L145.55 51.1513L130.518 25.1268L127.654 12.1719Z"
                  fill="#4B6C8C"/>
            <path
                d="M138.419 92.4229L147.511 87.1492L142.283 51.0359L133.114 25.8139L103.992 8.08203L64.8755 8.55972L33.9472 26.1387L23.625 67.2964L25.2589 82.9837L26.1046 100.085L138.419 92.4229Z"
                fill="url(#paint4_linear_3545_19972)"/>
            <path
                d="M89.9218 4.5476H79.0613C78.6577 4.5476 78.3309 4.18456 78.4078 3.7833L78.6192 2.42666C78.8499 1.03181 80.0609 0 81.4833 0H87.519C88.9414 0 90.1524 1.03181 90.3831 2.42666L90.5945 3.7833C90.6522 4.18456 90.3446 4.5476 89.9218 4.5476Z"
                fill="#4B6C8C"/>
            <path
                d="M117.85 6.24858L118.677 7.26128C120.022 8.90453 121.579 10.3567 123.309 11.5987C124.905 12.7451 127.134 14.4648 129.595 16.6622L128.903 13.968C128.211 11.3121 126.365 9.11471 123.867 7.96826L115.332 4.07031C116.274 4.64354 117.139 5.36963 117.85 6.24858Z"
                fill="url(#paint5_linear_3545_19972)"/>
            <path
                d="M146.088 41.1771L150.509 43.9286C151.335 44.4445 152.047 45.0942 152.623 45.8394L152.585 45.5527C152.335 43.1452 152.085 40.7185 151.97 38.311C151.508 29.4833 146.434 21.4581 138.534 17.2544L124.713 9.87891C125.636 11.1782 126.75 12.3247 128.038 13.2609L139.937 22.8912C145.396 27.2859 147.779 34.413 146.088 41.1771Z"
                fill="url(#paint6_linear_3545_19972)"/>
            <path d="M41.3476 12.1719L25.1434 23.56L20.7031 33.3813L23.4711 51.1513L38.4835 25.1268L41.3476 12.1719Z"
                  fill="#4B6C8C"/>
            <path
                d="M51.1509 6.24858L50.3244 7.26128C48.9788 8.90453 47.4218 10.3567 45.6918 11.5987C44.0964 12.7451 41.8667 14.4648 39.4062 16.6622L40.0982 13.968C40.7902 11.3121 42.6355 9.11471 45.1344 7.96826L53.669 4.07031C52.7271 4.64354 51.8621 5.36963 51.1509 6.24858Z"
                fill="url(#paint7_linear_3545_19972)"/>
            <path
                d="M51.5546 16.127L33.928 26.1393L23.625 67.297L25.2589 82.9843L26.1046 100.086L46.5953 98.6908C45.6534 51.5715 49.7477 25.2604 51.5546 16.127Z"
                fill="url(#paint8_linear_3545_19972)"/>
            <path
                d="M119.83 16.127L137.457 26.1393L147.76 67.297L146.126 82.9843L145.28 100.086L124.789 98.6908C125.712 51.5715 121.637 25.2604 119.83 16.127Z"
                fill="url(#paint9_linear_3545_19972)"/>
            <path
                d="M22.9124 41.1771L18.4914 43.9286C17.6648 44.4445 16.9536 45.0942 16.377 45.8394L16.4154 45.5527C16.6653 43.1452 16.9152 40.7185 17.0305 38.311C17.4918 29.4833 22.5664 21.4581 30.4667 17.2544L44.2873 9.87891C43.3647 11.1782 42.2498 12.3247 40.9619 13.2609L29.0635 22.8912C23.6044 27.2859 21.2209 34.413 22.9124 41.1771Z"
                fill="url(#paint10_linear_3545_19972)"/>
            <path
                d="M133.728 338.184C133.728 338.184 135.977 337.802 138.091 337.152C139.744 336.655 141.051 335.413 141.609 333.789C143.243 329.051 146.914 317.108 148.606 300.943L137.572 332.337L132.594 331.286L133.728 338.184Z"
                fill="#2C3E54"/>
            <path
                d="M143.782 81.5329C145.838 76.221 146.723 70.5269 146.377 64.8329L145.146 44.8846C144.608 28.4521 129.307 15.9175 123.291 11.5992C121.561 10.3572 120.004 8.90501 118.658 7.26176L117.832 6.24906C116.025 4.05169 113.334 2.77148 110.47 2.77148H58.4743C55.6295 2.77148 52.9192 4.05169 51.1123 6.24906L50.2858 7.26176C48.9402 8.90501 47.3832 10.3572 45.6533 11.5992C39.6368 15.9175 24.3553 28.4521 23.7978 44.8846L21.9141 75.6096L25.2395 83.0042C25.2395 83.0042 21.2413 28.0126 58.4743 17.5034C58.4743 17.5034 69.181 14.4271 84.4625 14.3507C99.7248 14.408 110.451 17.5034 110.451 17.5034C144.108 26.9808 144.108 72.7625 143.782 81.5329Z"
                fill="url(#paint11_linear_3545_19972)"/>
            <path
                d="M26.5075 99.1302C31.1016 88.2579 40.6933 80.1563 52.2842 77.7488C52.5725 77.6915 52.8801 77.6341 53.1877 77.5768C61.1648 76.1246 71.314 74.94 83.5392 74.7871H84.4427C96.6679 74.9209 106.817 76.1055 114.794 77.5768C116.524 77.9016 118.216 78.322 119.869 78.8379C129.038 81.7423 136.592 88.2962 140.975 96.8181L140.994 96.8564L134.016 149.173C134.016 149.173 125.77 146.02 83.7122 146.02C41.6544 146.02 34.6768 148.753 34.6768 148.753L26.123 100.066L26.5075 99.1302Z"
                fill="url(#paint12_linear_3545_19972)"/>
            <path
                d="M138.418 92.4242L142.128 85.2207C145.338 78.9152 146.818 71.8836 146.376 64.8329L145.146 44.8846L146.068 41.1777L150.489 43.9292C152.834 45.3814 154.295 47.9418 154.334 50.6933C154.449 57.8395 154.641 72.2658 154.641 83.5392C154.641 90.9721 154.103 98.3858 153.007 105.723H145.492L140.994 96.9336L138.418 92.4242Z"
                fill="url(#paint13_linear_3545_19972)"/>
            <path
                d="M126.365 315.465C126.365 315.465 131.651 323.299 133.189 335.069C136.591 334.362 139.225 331.707 139.917 328.324L140.551 325.133C141.243 321.713 142.32 318.369 143.761 315.178L146.914 308.185C150.066 301.192 152.007 293.721 152.642 286.078C154.045 269.015 155.506 238.156 149.585 222.545C149.585 222.545 147.471 265.174 145.126 284.568L137.437 283.938L126.365 315.465Z"
                fill="url(#paint14_linear_3545_19972)"/>
            <path d="M40.5977 167.076H128.096L123.175 258.907H45.4416L40.5977 167.076Z"
                  fill="url(#paint15_linear_3545_19972)"/>
            <path
                d="M30.5828 92.4242L26.8729 85.2207C23.6628 78.9152 22.1827 71.8836 22.6248 64.8329L23.8551 44.8846L22.9324 41.1777L18.5113 43.9292C16.1662 45.3814 14.7054 47.9418 14.6669 50.6933C14.5516 57.8395 14.3594 72.2658 14.3594 83.5392C14.3594 90.9721 14.8976 98.3858 15.9932 105.723H23.5091L28.007 96.9336L30.5828 92.4242Z"
                fill="url(#paint16_linear_3545_19972)"/>
            <path
                d="M153.047 105.703C153.047 105.703 151.221 271.385 142.552 307.384L139.688 292.862L145.531 105.703H153.047Z"
                fill="url(#paint17_linear_3545_19972)"/>
            <path
                d="M141.283 267.105C142.282 267.64 144.474 268.71 147.203 269.437C147.184 269.609 147.184 269.8 147.165 269.972C144.531 269.284 142.379 268.271 141.264 267.679C141.264 267.488 141.264 267.297 141.283 267.105Z"
                fill="url(#paint18_linear_3545_19972)"/>
            <path
                d="M145.742 189.337C145.722 189.528 145.722 189.7 145.703 189.891C146.587 189.662 149.125 188.917 151.201 187.503C151.201 187.273 151.22 187.063 151.22 186.834C149.317 188.267 146.78 189.05 145.742 189.337Z"
                fill="url(#paint19_linear_3545_19972)"/>
            <path
                d="M23.2208 189.318C22.1636 189.031 19.6647 188.229 17.7617 186.834C17.7617 187.063 17.7809 187.273 17.7809 187.503C19.8377 188.898 22.3173 189.643 23.24 189.891C23.24 189.7 23.2208 189.509 23.2208 189.318Z"
                fill="url(#paint20_linear_3545_19972)"/>
            <path opacity="0.1"
                  d="M140.955 96.8186C136.592 88.2966 129.038 81.7236 119.85 78.8384C118.216 78.3225 116.524 77.9021 114.775 77.5773C111.43 76.9658 107.701 76.4117 103.588 75.9531C111.161 96.2263 118.85 120.321 125.232 147.702C132.036 148.466 133.978 149.212 133.978 149.212L140.994 96.8759L140.955 96.8186Z"
                  fill="url(#paint21_linear_3545_19972)"/>
            <path
                d="M145.531 105.703C141.725 124.218 138.957 142.906 137.266 161.727C134.959 187.312 132.499 224.495 133.249 260.837C133.345 265.519 133.998 270.181 135.132 274.729L139.688 292.881C139.688 292.881 143.513 231.087 145.781 189.031C148.03 146.956 145.531 105.703 145.531 105.703Z"
                fill="url(#paint22_linear_3545_19972)"/>
            <path
                d="M135.112 274.729C133.977 270.182 133.324 265.519 133.228 260.838C132.478 224.514 134.958 187.331 137.245 161.727C138.937 142.906 141.705 124.219 145.511 105.704L141.013 96.9141C141.013 96.9141 132.67 146.403 131.709 166.695C131.363 173.956 130.498 192.586 129.518 213.528C127.749 251.208 125.654 296.397 125.654 296.397C125.654 296.397 131.882 295.021 133.112 300.505L137.437 283.939L135.112 274.729Z"
                fill="url(#paint23_linear_3545_19972)"/>
            <path
                d="M125.675 296.396L122.1 323.605C124.502 323.032 126.425 321.274 127.174 318.943L133.114 300.504C131.922 295.02 125.675 296.396 125.675 296.396Z"
                fill="url(#paint24_linear_3545_19972)"/>
            <path
                d="M133.497 149C133.497 149 131.46 148.446 129.48 148.217C129.48 148.217 122.56 230.494 121.926 289.88H126.097C126.116 289.88 129.999 191.687 133.497 149Z"
                fill="url(#paint25_linear_3545_19972)"/>
            <path
                d="M148.029 118.18V126.549C148.029 126.95 148.356 127.256 148.741 127.256H152.277L150.317 120.568L148.029 118.18Z"
                fill="#2C3E54"/>
            <path
                d="M152.47 121.142L149.721 117.683C149.529 117.435 149.183 117.396 148.914 117.568L148.029 118.18L151.201 122.479L152.47 121.142Z"
                fill="#4B6C8C"/>
            <path
                d="M150.336 120.568C150.336 120.568 163.215 122.097 168.789 131.173C169.443 132.243 168.52 133.581 167.27 133.37C164.426 132.874 159.966 131.976 156.352 130.867C152.431 129.664 149.74 125.918 150.124 121.849C150.144 121.409 150.221 120.989 150.336 120.568Z"
                fill="url(#paint26_linear_3545_19972)"/>
            <path
                d="M153.642 165.721L153.449 165.53C153.007 165.09 152.392 164.842 151.758 164.842L151.662 168.606C151.739 168.625 151.796 168.644 151.873 168.663C152.565 168.893 153.027 169.523 153.046 170.249C153.084 171.491 153.161 173.937 153.065 175.771C153.027 176.65 152.315 177.376 151.431 177.434L151.277 183.204C151.297 183.204 151.316 183.204 151.316 183.204C152.604 183.032 153.622 182.058 153.872 180.797C155.468 172.752 153.642 165.721 153.642 165.721Z"
                fill="url(#paint27_linear_3545_19972)"/>
            <path
                d="M150.432 246.698L150.24 246.507C149.798 246.048 149.202 245.781 148.568 245.762L148.356 249.526C148.433 249.545 148.491 249.564 148.568 249.602C149.241 249.851 149.683 250.5 149.702 251.227C149.721 252.468 149.702 254.914 149.567 256.749C149.491 257.628 148.779 258.315 147.876 258.354L147.568 264.124C147.588 264.124 147.607 264.124 147.607 264.124C148.895 263.99 149.952 263.035 150.221 261.793C152.066 253.787 150.432 246.698 150.432 246.698Z"
                fill="url(#paint28_linear_3545_19972)"/>
            <path
                d="M59.9545 339.331V340.822C59.9545 340.822 47.7101 340.936 35.2734 338.185L35.7924 335.07L36.4075 331.287C36.4268 331.287 57.2442 335.185 59.9545 339.331Z"
                fill="#2C3E54"/>
            <path
                d="M35.2724 338.186C35.2724 338.186 33.0234 337.804 30.909 337.154C29.2559 336.657 27.9488 335.415 27.3913 333.791C25.7575 329.053 22.0861 317.11 20.3945 300.945L31.428 332.339L36.4065 331.288L35.2724 338.186Z"
                fill="#2C3E54"/>
            <path
                d="M42.636 315.467C42.636 315.467 37.35 323.301 35.8122 335.071C32.4099 334.364 29.7765 331.708 29.0845 328.326L28.4502 325.135C27.7582 321.715 26.6817 318.371 25.2401 315.18L22.0877 308.187C18.9353 301.194 16.9938 293.723 16.3595 286.08C14.9563 269.016 13.4954 238.158 19.4158 222.547C19.4158 222.547 21.5302 265.176 23.8753 284.57L31.5834 283.94L42.636 315.467Z"
                fill="url(#paint29_linear_3545_19972)"/>
            <path
                d="M15.9551 105.703C15.9551 105.703 17.7812 271.385 26.4503 307.384L29.3144 292.862L23.4709 105.703H15.9551Z"
                fill="url(#paint30_linear_3545_19972)"/>
            <path
                d="M23.4705 105.703C27.2764 124.218 30.0444 142.906 31.7359 161.727C34.0426 187.312 36.503 224.495 35.7533 260.837C35.6572 265.519 35.0037 270.181 33.8696 274.729L29.314 292.881C29.314 292.881 25.4888 231.087 23.2206 189.031C20.9524 146.975 23.4705 105.703 23.4705 105.703Z"
                fill="url(#paint31_linear_3545_19972)"/>
            <path
                d="M33.8893 274.729C35.0234 270.182 35.677 265.519 35.7731 260.838C36.5228 224.514 34.0431 187.331 31.7557 161.727C30.0642 142.906 27.2962 124.219 23.4902 105.704L27.9882 96.9141C27.9882 96.9141 36.3305 146.403 37.2916 166.695C37.6376 173.956 38.5026 192.586 39.483 213.528C41.2514 251.208 43.3466 296.397 43.3466 296.397C43.3466 296.397 37.1186 295.021 35.8884 300.505L31.5827 283.939L33.8893 274.729Z"
                fill="url(#paint32_linear_3545_19972)"/>
            <path
                d="M43.3276 296.398L46.9029 323.607C44.5001 323.034 42.5779 321.276 41.8283 318.945L35.8887 300.506C37.0804 295.022 43.3276 296.398 43.3276 296.398Z"
                fill="url(#paint33_linear_3545_19972)"/>
            <path
                d="M35.5039 149.002C35.5039 149.002 37.5414 148.448 39.5213 148.219C39.5213 148.219 46.4412 230.496 47.0756 289.882H42.9044C42.8852 289.882 39.0023 191.688 35.5039 149.002Z"
                fill="url(#paint34_linear_3545_19972)"/>
            <path
                d="M20.9724 118.182V126.551C20.9724 126.952 20.6456 127.258 20.2612 127.258H16.7051L18.6657 120.57L20.9724 118.182Z"
                fill="#2C3E54"/>
            <path
                d="M16.5312 121.142L19.28 117.683C19.4722 117.435 19.8182 117.396 20.0873 117.568L20.9715 118.18L17.7999 122.479L16.5312 121.142Z"
                fill="#4B6C8C"/>
            <path
                d="M18.6653 120.568C18.6653 120.568 5.7865 122.097 0.212117 131.173C-0.441431 132.243 0.481226 133.581 1.73066 133.37C4.57552 132.874 9.03503 131.976 12.6488 130.867C16.5701 129.664 19.2611 125.918 18.8767 121.849C18.8575 121.409 18.7806 120.989 18.6653 120.568Z"
                fill="url(#paint35_linear_3545_19972)"/>
            <path
                d="M15.3591 165.721L15.5513 165.53C15.9935 165.09 16.6086 164.842 17.2429 164.842L17.339 168.606C17.2621 168.625 17.2044 168.644 17.1275 168.663C16.4356 168.893 15.9742 169.523 15.955 170.249C15.9166 171.491 15.8397 173.937 15.9358 175.771C15.9742 176.65 16.6854 177.376 17.5697 177.434L17.7234 183.204C17.7042 183.204 17.685 183.204 17.685 183.204C16.3971 183.032 15.3783 182.058 15.1285 180.797C13.533 172.752 15.3591 165.721 15.3591 165.721Z"
                fill="url(#paint36_linear_3545_19972)"/>
            <path
                d="M18.5697 246.698L18.7619 246.507C19.204 246.048 19.7999 245.781 20.4342 245.762L20.6457 249.526C20.5688 249.545 20.5111 249.564 20.4342 249.602C19.7615 249.851 19.3194 250.5 19.3001 251.227C19.2809 252.468 19.3001 254.914 19.4347 256.749C19.5116 257.628 20.2228 258.315 21.1262 258.354L21.4338 264.124C21.4146 264.124 21.3953 264.124 21.3953 264.124C20.1075 263.99 19.0502 263.035 18.7811 261.793C16.9358 253.787 18.5697 246.698 18.5697 246.698Z"
                fill="url(#paint37_linear_3545_19972)"/>
            <path
                d="M27.6997 267.105C26.7001 267.64 24.5088 268.71 21.7793 269.437C21.7985 269.609 21.7985 269.8 21.8177 269.972C24.4512 269.284 26.604 268.271 27.7189 267.679C27.7189 267.488 27.6997 267.297 27.6997 267.105Z"
                fill="url(#paint38_linear_3545_19972)"/>
            <path
                d="M145.742 189.337C145.722 189.528 145.722 189.7 145.703 189.891C146.587 189.662 149.125 188.917 151.201 187.503C151.201 187.273 151.22 187.063 151.22 186.834C149.317 188.267 146.78 189.05 145.742 189.337Z"
                fill="url(#paint39_linear_3545_19972)"/>
            <path
                d="M23.2208 189.318C22.1636 189.031 19.6647 188.229 17.7617 186.834C17.7617 187.063 17.7809 187.273 17.7809 187.503C19.8377 188.898 22.3173 189.643 23.24 189.891C23.24 189.7 23.2208 189.509 23.2208 189.318Z"
                fill="url(#paint40_linear_3545_19972)"/>
            <path
                d="M145.53 105.703C145.088 107.805 144.684 109.907 144.281 112.028C144.877 125.155 145.934 156.835 144.204 189.012C142.32 223.864 139.379 272.245 138.418 287.817L139.687 292.862C139.687 292.862 143.512 231.068 145.78 189.012C148.048 146.956 145.53 105.703 145.53 105.703Z"
                fill="url(#paint41_linear_3545_19972)"/>
            <path
                d="M145.261 181.062C142.07 184.387 137.399 186.432 135.246 187.253C134.938 191.916 134.631 196.731 134.381 201.699C138.533 200.953 142.396 198.699 144.511 197.266L145.261 181.062Z"
                fill="#2C3E54"/>
            <path
                d="M23.4314 105.703C23.8735 107.805 24.2772 109.907 24.6808 112.028C24.085 125.155 23.0277 156.835 24.7577 189.012C26.6415 223.864 29.5825 272.245 30.5436 287.817L29.2749 292.862C29.2749 292.862 25.4497 231.068 23.1815 189.012C20.9133 146.956 23.4314 105.703 23.4314 105.703Z"
                fill="url(#paint42_linear_3545_19972)"/>
            <path
                d="M23.6816 181.062C26.8725 184.387 31.5434 186.432 33.6963 187.253C34.0039 191.916 34.3114 196.731 34.5613 201.699C30.4093 200.953 26.5457 198.699 24.4313 197.266L23.6816 181.062Z"
                fill="#2C3E54"/>
            <path d="M111.507 268.08H106.721V286.099H111.507V268.08Z" fill="url(#paint43_linear_3545_19972)"/>
            <path
                d="M106.856 276.946V276.487H106.837L106.722 268.08L105.203 272.895V276.64V277.233V280.978L106.722 285.793L106.837 277.385H106.856V276.946Z"
                fill="url(#paint44_linear_3545_19972)"/>
            <path
                d="M111.392 276.946L111.373 276.487H111.392L111.508 268.08L113.026 272.895V276.64V277.233V280.978L111.508 285.793L111.392 277.385H111.373L111.392 276.946Z"
                fill="url(#paint45_linear_3545_19972)"/>
            <path d="M98.0148 268.08H93.2285V286.099H98.0148V268.08Z" fill="url(#paint46_linear_3545_19972)"/>
            <path
                d="M93.3624 276.946V276.487L93.2278 268.08L91.7285 272.895V276.64V277.233V280.978L93.2278 285.793L93.3624 277.385V276.946Z"
                fill="url(#paint47_linear_3545_19972)"/>
            <path
                d="M97.8984 276.946V276.487L98.033 268.08L99.5515 272.895V276.64V277.233V280.978L98.033 285.793L97.8984 277.385V276.946Z"
                fill="url(#paint48_linear_3545_19972)"/>
            <path d="M75.9855 268.08H71.1992V286.099H75.9855V268.08Z" fill="url(#paint49_linear_3545_19972)"/>
            <path
                d="M71.3155 276.946L71.3347 276.487H71.3155L71.2002 268.08L69.6816 272.895V276.64V277.233V280.978L71.2002 285.793L71.3155 277.385H71.3347L71.3155 276.946Z"
                fill="url(#paint50_linear_3545_19972)"/>
            <path
                d="M75.8516 276.946V276.487H75.8708L75.9861 268.08L77.5047 272.895V276.64V277.233V280.978L75.9861 285.793L75.8708 277.385H75.8516V276.946Z"
                fill="url(#paint51_linear_3545_19972)"/>
            <path d="M62.4914 268.08H57.7051V286.099H62.4914V268.08Z" fill="url(#paint52_linear_3545_19972)"/>
            <path
                d="M57.8406 276.946V276.487H57.8214L57.706 268.08L56.1875 272.895V276.64V277.233V280.978L57.706 285.793L57.8214 277.385H57.8406V276.946Z"
                fill="url(#paint53_linear_3545_19972)"/>
            <path
                d="M62.3766 276.946L62.3574 276.487H62.3766L62.492 268.08L64.0105 272.895V276.64V277.233V280.978L62.492 285.793L62.3766 277.385H62.3574L62.3766 276.946Z"
                fill="url(#paint54_linear_3545_19972)"/>
            <path d="M84.4062 291.735L86.6744 288.735V279.907C86.6744 278.665 85.6557 277.652 84.4062 277.652V291.735Z"
                  fill="url(#paint55_linear_3545_19972)"/>
            <path d="M84.483 291.735L82.2148 288.735V279.907C82.2148 278.665 83.2336 277.652 84.483 277.652V291.735Z"
                  fill="url(#paint56_linear_3545_19972)"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_3545_19972" x1="84.3973" y1="355.862" x2="84.3973" y2="316.507"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3545_19972" x1="38.774" y1="278.547" x2="131.452" y2="278.547"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3545_19972" x1="42.9109" y1="310.824" x2="125.678" y2="310.824"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3545_19972" x1="157.693" y1="155.804" x2="27.3761" y2="155.804"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3545_19972" x1="85.5737" y1="89.4885" x2="85.5737" y2="-31.9262"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint5_linear_3545_19972" x1="122.452" y1="20.7435" x2="122.452" y2="-32.5621"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint6_linear_3545_19972" x1="138.684" y1="49.3351" x2="138.684" y2="13.4176"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint7_linear_3545_19972" x1="46.5514" y1="20.7435" x2="46.5514" y2="-32.5621"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint8_linear_3545_19972" x1="37.5917" y1="74.4598" x2="37.5917" y2="20.5299"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.7521" stop-color="#B8D4FA"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint9_linear_3545_19972" x1="133.791" y1="74.4598" x2="133.791" y2="20.5299"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.7521" stop-color="#B8D4FA"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint10_linear_3545_19972" x1="30.3183" y1="49.3351" x2="30.3183" y2="13.4176"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint11_linear_3545_19972" x1="84.1956" y1="76.5586" x2="84.1956" y2="-27.1309"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#CDE5FF"/>
                <stop offset="0.1095" stop-color="#CAE3FE"/>
                <stop offset="0.1799" stop-color="#C2DCFC"/>
                <stop offset="0.2394" stop-color="#B3D0F9"/>
                <stop offset="0.2927" stop-color="#9EBFF4"/>
                <stop offset="0.3414" stop-color="#83A9ED"/>
                <stop offset="0.3508" stop-color="#7DA4EC"/>
                <stop offset="0.3597" stop-color="#80A6ED"/>
                <stop offset="0.4568" stop-color="#9CBDF3"/>
                <stop offset="0.5616" stop-color="#B2CFF9"/>
                <stop offset="0.6764" stop-color="#C1DBFC"/>
                <stop offset="0.809" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint12_linear_3545_19972" x1="49.9186" y1="111.994" x2="97.4553" y2="111.994"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="1" stop-color="#5B7DA8"/>
            </linearGradient>
            <linearGradient id="paint13_linear_3545_19972" x1="146.544" y1="109.007" x2="146.544" y2="43.1568"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint14_linear_3545_19972" x1="161.282" y1="278.797" x2="-114.106" y2="278.797"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint15_linear_3545_19972" x1="40.6" y1="212.993" x2="128.087" y2="212.993"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="1" stop-color="#5B7DA8"/>
            </linearGradient>
            <linearGradient id="paint16_linear_3545_19972" x1="22.4592" y1="109.007" x2="22.4592" y2="43.1568"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint17_linear_3545_19972" x1="146.356" y1="393.675" x2="146.356" y2="-8.58607"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint18_linear_3545_19972" x1="142.72" y1="268.537" x2="131.708" y2="268.537"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint19_linear_3545_19972" x1="144.924" y1="188.365" x2="169.515" y2="188.365"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint20_linear_3545_19972" x1="23.9583" y1="188.359" x2="5.86502" y2="188.359"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint21_linear_3545_19972" x1="103.613" y1="112.57" x2="140.986" y2="112.57"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint22_linear_3545_19972" x1="139.906" y1="311.879" x2="139.906" y2="63.1062"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.000744048" stop-color="#2C3E54"/>
                <stop offset="0.718" stop-color="#4D6B8F"/>
                <stop offset="1" stop-color="#5B7DA8"/>
            </linearGradient>
            <linearGradient id="paint23_linear_3545_19972" x1="184.414" y1="198.709" x2="-64.6137" y2="198.709"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint24_linear_3545_19972" x1="132.888" y1="309.921" x2="-68.1784" y2="309.921"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint25_linear_3545_19972" x1="18.3281" y1="333.955" x2="201.905" y2="138.941"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint26_linear_3545_19972" x1="165.896" y1="131.123" x2="186.552" y2="141.513"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint27_linear_3545_19972" x1="152.911" y1="196.734" x2="152.911" y2="132.476"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint28_linear_3545_19972" x1="149.348" y1="288.894" x2="149.348" y2="209.152"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint29_linear_3545_19972" x1="7.72004" y1="278.799" x2="283.108" y2="278.799"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint30_linear_3545_19972" x1="22.6469" y1="393.675" x2="22.6469" y2="-8.58607"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint31_linear_3545_19972" x1="29.0959" y1="311.879" x2="29.0959" y2="63.1062"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.000744048" stop-color="#2C3E54"/>
                <stop offset="0.718" stop-color="#4D6B8F"/>
                <stop offset="1" stop-color="#5B7DA8"/>
            </linearGradient>
            <linearGradient id="paint32_linear_3545_19972" x1="-15.4123" y1="198.709" x2="233.615" y2="198.709"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint33_linear_3545_19972" x1="36.1147" y1="309.923" x2="237.181" y2="309.923"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint34_linear_3545_19972" x1="150.674" y1="333.957" x2="-32.9028" y2="138.943"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint35_linear_3545_19972" x1="3.10586" y1="131.123" x2="-17.5502" y2="141.513"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint36_linear_3545_19972" x1="16.0903" y1="196.734" x2="16.0903" y2="132.476"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint37_linear_3545_19972" x1="19.655" y1="288.894" x2="19.655" y2="209.152"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint38_linear_3545_19972" x1="26.2521" y1="268.537" x2="37.2641" y2="268.537"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint39_linear_3545_19972" x1="144.924" y1="188.365" x2="169.515" y2="188.365"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint40_linear_3545_19972" x1="23.9583" y1="188.359" x2="5.86502" y2="188.359"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint41_linear_3545_19972" x1="138.407" y1="199.289" x2="146.71" y2="199.289"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="1" stop-color="#5B7DA8"/>
            </linearGradient>
            <linearGradient id="paint42_linear_3545_19972" x1="30.5481" y1="199.289" x2="22.2453" y2="199.289"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="1" stop-color="#5B7DA8"/>
            </linearGradient>
            <linearGradient id="paint43_linear_3545_19972" x1="109.116" y1="292.454" x2="109.116" y2="265.99"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint44_linear_3545_19972" x1="116.122" y1="286.281" x2="118.247" y2="288.418"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint45_linear_3545_19972" x1="118.519" y1="283.899" x2="120.643" y2="286.036"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint46_linear_3545_19972" x1="95.6299" y1="292.454" x2="95.6299" y2="265.99"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint47_linear_3545_19972" x1="109.379" y1="292.984" x2="111.504" y2="295.122"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint48_linear_3545_19972" x1="111.775" y1="290.602" x2="113.9" y2="292.74"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint49_linear_3545_19972" x1="73.5868" y1="292.454" x2="73.5868" y2="265.99"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint50_linear_3545_19972" x1="98.3585" y1="303.94" x2="100.483" y2="306.077"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint51_linear_3545_19972" x1="100.755" y1="301.558" x2="102.88" y2="303.695"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint52_linear_3545_19972" x1="60.0992" y1="292.454" x2="60.0992" y2="265.99"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint53_linear_3545_19972" x1="91.6145" y1="310.643" x2="93.7393" y2="312.781"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint54_linear_3545_19972" x1="94.0108" y1="308.261" x2="96.1356" y2="310.399"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint55_linear_3545_19972" x1="77.8841" y1="284.702" x2="83.3801" y2="284.702"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.1849" stop-color="#9ABCF3"/>
                <stop offset="0.5247" stop-color="#CDE5FF"/>
                <stop offset="0.6341" stop-color="#C5DEFD"/>
                <stop offset="0.807" stop-color="#AECCF8"/>
                <stop offset="1" stop-color="#8DB1F0"/>
            </linearGradient>
            <linearGradient id="paint56_linear_3545_19972" x1="78.9042" y1="284.702" x2="105.507" y2="284.702"
                            gradientUnits="userSpaceOnUse">
                <stop offset="0.00229415" stop-color="#7DA4EC"/>
                <stop offset="0.0344791" stop-color="#85AAEE"/>
                <stop offset="0.1681" stop-color="#9FC0F4"/>
                <stop offset="0.3151" stop-color="#B3D0F9"/>
                <stop offset="0.4804" stop-color="#C2DCFC"/>
                <stop offset="0.6789" stop-color="#CAE3FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <clipPath id="clip0_3545_19972">
                <rect width="169" height="343" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
